import { Routes } from '@angular/router';
import { GiftsAssessmentComponent } from './gifts-assessment/gifts-assessment.component';
import { TabsPage } from './tabs/tabs.page';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { QuestionsComponent } from './questions/questions.component';
import { FirebaseMyAccountComponent } from './account/firebase/my-account/my-account.component';
import { FirebaseLoginComponent } from './account/firebase/login/login.component';
import { FirebaseRegistrationComponent } from './account/firebase/registration/registration.component';
import { FirebasePasswordResetComponent } from './account/firebase/password-reset/password-reset.component';
import { FirebaseVerifyEmailComponent } from './account/firebase/verify-email/verify-email.component';

export const routes: Routes = [
  {
    path: '',
    component: TabsPage,
    children: [
      { path: 'home', component: HomeComponent},
      { path: 'about', component: AboutComponent},
      { path: 'spiritual-gifts-test', component: GiftsAssessmentComponent},
      { path: 'questions', component: QuestionsComponent},
      { path: 'submissions', component: FirebaseMyAccountComponent},
      { path: '', redirectTo: '/spiritual-gifts-test', pathMatch: 'full'},
      { path: 'firebase', children: [
        {path: '', redirectTo: 'settings', pathMatch: 'full'},
        {path: 'login', component: FirebaseLoginComponent},
        {path: 'register', component: FirebaseRegistrationComponent},
        {path: 'password-reset', component: FirebasePasswordResetComponent},
        {path: 'verify-email', component: FirebaseVerifyEmailComponent},
      ]}
    ],
  }
];
